<template>
  <div
    class="card-company-plan"
    :class="{ 'card-company-plan--expired': isPlanExpired }"
  >
    <a class="card-company-plan-link" @click="routerPage(plan)">
      <div class="card-company-plan__header">
        <p>
          {{ plan.name }}
        </p>
        <div
          class="card-company-plan__status"
          :class="{
            'card-company-plan__status--expired': isPlanExpired,
            'card-company-plan__status--active': plan.is_active,
          }"
        >
          <template v-if="isPlanExpired"> Plano expirado </template>
          <template v-else-if="plan.is_active"> Plano ativado </template>
          <template v-else> Plano desativado </template>
        </div>
      </div>
      <div class="card-company-plan__text">
        <p>
          Empresa: <b>{{ plan.company_name }}</b>
        </p>
        <p>
          Data de expiração: <b>{{ plan.expiration_date | dateFormat }}</b>
        </p>
      </div>
    </a>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPlanExpired() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate() + 1;

      const currentDateTime = new Date(year, month, day).getTime();
      const expirationDateTime = new Date(this.plan.expiration_date).getTime();

      return currentDateTime > expirationDateTime;
    },
  },
  methods: {
    ...mapActions(["getSlugify"]),
    async routerPage(plan) {
      this.$router.push({
        name: "EditPlanCompany",
        params: {
          id: plan.id_company,
          idCompanyHasPlan: plan.id,
          slug: await this.getSlugify(plan.company_name),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-company-plan {
  position: relative;
  height: 200px;
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    height: 100%;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__text {
    padding: 15px;
    height: 100%;
    text-align: left;
    p {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--black);
      margin-bottom: 0;
    }
  }
  &__header {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--gray-light);
    p {
      font-size: 20px;
      font-family: "Font Bold";
      color: var(--black);
      margin-bottom: 0;
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
  &__status {
    width: max-content;
    background: var(--yellow-dark);
    padding: 5px 15px;
    border-radius: 30px;
    font-family: "Font Semibold";
    color: var(--white);
    font-size: 12px;
    &--expired {
      background: var(--red-super-dark);
      color: var(--white);
    }
    &--active {
      background: var(--green-2);
    }
  }
  &--expired {
    background: var(--gray-light);
    .card-company-plan__header {
      border-bottom: 1px solid var(--white);
    }
  }
}
</style>
